import { createFileRoute } from '@tanstack/react-router';
import { CustomersListPage } from '@/features/customers/customers-list-page.js';

export const Route = createFileRoute('/_app/customers/')({
  component: CustomersListPage,
});
